module.exports = __webpack_public_path__ + "static/img/img_t1.19539c79.webp";